import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TeamMember } from '../../../app.models';
import { AppService } from '../../../app.service';
import { TeamMemberService } from '../team-teammembers.service';

@Component({
  selector: 'app-type-table',
  templateUrl: './type-table.component.html',
  styleUrls: ['./type-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule],
})
export class TypeTableComponent implements OnInit {
  teamMembersWithType: TeamMember[];
  teamTypes: Set<string>;
  initialsByType: { [mbtiType: string]: SafeHtml };
  mbtiTypes: string[];
  activeType: string;

  constructor(
    private appService: AppService,
    private domSanitizer: DomSanitizer,
    private teamMemberService: TeamMemberService,
  ) {}

  ngOnInit() {
    this.initialsByType = {};

    this.mbtiTypes = this.appService.getMbtiTypes();

    // Need to initialize each diamond with transparent blank circle to prevent "NULL" from appearing on IE and Edge
    this.mbtiTypes.forEach((mbtiType) => {
      this.initialsByType[mbtiType] = this.domSanitizer.bypassSecurityTrustHtml(
        `<div class="type-table-initials one" style="background: transparent"></div>`,
      );
    });

    this.teamMembersWithType = this.appService.getTeamInfo().teamMembers.filter((tm) => tm.status == 'Completed');

    // Used to determine if the type text in the diamond should be light or dark
    this.teamTypes = new Set();
    this.teamMembersWithType.forEach((tm) => {
      this.teamTypes.add(tm.mbtiType);
    });

    // Put circles in the diamond
    this.teamTypes.forEach((mbtiType) => {
      const selectedTeamMembers = this.teamMembersWithType.filter((tm) => tm.mbtiType === mbtiType);

      switch (selectedTeamMembers.length) {
        case 1:
          this.initialsByType[mbtiType] = this.domSanitizer.bypassSecurityTrustHtml(
            `<div class="type-table-initials one" style="background: ${selectedTeamMembers[0].color}">${selectedTeamMembers[0].initials}</div>`,
          );
          break;
        case 2:
          this.initialsByType[mbtiType] = this.domSanitizer.bypassSecurityTrustHtml(
            `<div class="type-table-initials two left" style="background: ${selectedTeamMembers[0].color}">${selectedTeamMembers[0].initials}</div>
                   <div class="type-table-initials two right" style="background: ${selectedTeamMembers[1].color}">${selectedTeamMembers[1].initials}</div>`,
          );
          break;
        case 3:
          this.initialsByType[mbtiType] = this.domSanitizer.bypassSecurityTrustHtml(
            `<div class="type-table-initials three left" style="background: ${selectedTeamMembers[0].color}">${selectedTeamMembers[0].initials}</div>
                   <div class="type-table-initials three center" style="background: ${selectedTeamMembers[1].color}">${selectedTeamMembers[1].initials}</div>
                   <div class="type-table-initials three right" style="background: ${selectedTeamMembers[2].color}">${selectedTeamMembers[2].initials}</div>`,
          );
          break;
        default:
          this.initialsByType[mbtiType] = this.domSanitizer.bypassSecurityTrustHtml(
            `<div class="type-table-initials three left" style="background: ${selectedTeamMembers[0].color}">${selectedTeamMembers[0].initials}</div>
                   <div class="type-table-initials three center" style="background: ${selectedTeamMembers[1].color}">${selectedTeamMembers[1].initials}</div>
                   <div class="type-table-initials three right" style="background: #929694">${selectedTeamMembers.length - 2}</div>`,
          );
      }
    });

    this.teamMemberService.currentActiveType.subscribe((activeType) => {
      this.activeType = activeType;
    });
  }

  isActiveType(type) {
    return type === this.activeType;
  }
}
